import $ from 'jquery'
import { closeVideoModal } from './hero'
import { closeCaseStudy } from './case-studies'

$(document).on('keyup', function (e) {
  if (e.key === 'Escape') {
    closeVideoModal()
    closeCaseStudy()
  }
})
